import { render, staticRenderFns } from "./Interactable.vue?vue&type=template&id=cbab3aa8&scoped=true"
import script from "./Interactable.vue?vue&type=script&lang=js"
export * from "./Interactable.vue?vue&type=script&lang=js"
import style0 from "./Interactable.vue?vue&type=style&index=0&id=cbab3aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab3aa8",
  null
  
)

export default component.exports